export const metaTags = {
  title: 'Traumatólogo en Monterrey | Dr. Andrés B. Acosta Flores',
  desc: 'Traumatología & Ortopedia en Monterrey.',
  image: 'https://frontpage-assets.s3.amazonaws.com/acostaflores.com/frontpage/logo.png',
  keyworkds: ['traumatologo', 'ortopedia', 'monterrey', 'doctor', 'andres', 'acosta', 'flores'],
  url: "https://dr.acostaflores.com"
};